<div class="modal-header">
  <h5 class="modal-title" id="editUserLabel">Duplica</h5>
  <button type="button" class="close" (click)="modalService.dismiss()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>


<div class="modal-body">
  <div class="row">
    <div class="col-lg-12">
        <ng-multiselect-dropdown
          [settings]="dropdownSettings"
          [disabled]="!permission.HasCapacity(['gestione-acquisti'])"
          [placeholder]="'Prodotto'"
          [data]="List"
          [(ngModel)]="duplicato.prodottoObject"
          (ngModelChange)="onProdottoChange()"
        >
        </ng-multiselect-dropdown>
    </div>
    <div class="col-lg-12">
      <div class="form-group">
        <label for="quantita" class="control-label col-form-label">{{'Quantità' | translate}}:</label>
        <input [(ngModel)]="qty" min="1" [max]="Voce.quantita - 1" [readOnly]="!permission.HasCapacity(['gestione-acquisti'])" (ngModelChange)="onQtyChange()" type="number" class="form-control" id="quantita" placeholder="{{'Quantità' | translate}}">
      </div>
    </div>
    <div class="col-lg-12">
      <label class="mb-0 text-dark">Brand</label>
      <input type="text" [readOnly]="!permission.HasCapacity(['gestione-acquisti'])" class="form-control" [(ngModel)]="duplicato.brand">
    </div>
  </div>
  <div class="d-md-flex align-items-center p-3" style="padding-right: 25px; margin-top: 25px;">
    <button type="submit" (click)="Duplica()" class="ml-auto btn btn-info p-2 waves-effect waves-light">
      <span class="text-white"> Duplica </span>
      <i class="far fa-copy"></i>
    </button>
  </div>
</div>
